// eslint-disable-next-line one-var
declare const WORKSPACE, BUILD_MODE, VERSION
class Configuration {
  private json = window.initialConfiguration
  public getProvider() {
    return 'zervant'
  }

  public getBrand() {
    return 'zervant'
  }

  public getStripeApiKey() {
    return this.json?.stripeApiKey || ''
  }

  public getStripeApiKeyV2() {
    return this.json?.stripeApiKeyV2 || ''
  }

  public getStripeConnectId() {
    return this.json?.stripeConnectId || null
  }

  public getSegmentWriteKey() {
    return this.json?.segmentWriteKey || null
  }

  public getDatadogApplicationId() {
    return this.json?.datadogApplicationId || ''
  }

  public getDatadogClientToken() {
    return this.json?.datadogClientToken || ''
  }

  public getVarsFromWebpackDefinePlugin() {
    // these are resolved by Webpack's definePlugin
    return {
      workspace: WORKSPACE,
      buildMode: BUILD_MODE,
      version: VERSION,
    }
  }
}

export const Config = new Configuration()
